import MaterialStack, { StackProps } from '@mui/material/Stack';

export function Stack(props: StackProps) {
    return <MaterialStack data-testid={'Stack-container'} {...props} />;
}

export default Stack;
